export const TRIAGE_FLAG = 'alexknows-triage-mode'

export function triageRequested(search: string): boolean {
  for (const [key, value] of Array.from(new URLSearchParams(search))) {
    if (key === 'triage' || value === 'triage') return true
  }
  return false
}

// Once a tab opens with ?triage it stays in triage mode across in-app
// navigation until the bar's Exit button clears the flag.
export function triageEnabled(): boolean {
  const requested = triageRequested(window.location.search)
  try {
    if (requested) sessionStorage.setItem(TRIAGE_FLAG, '1')
    return requested || sessionStorage.getItem(TRIAGE_FLAG) === '1'
  } catch {
    return requested
  }
}

export function exitTriage(): void {
  try {
    sessionStorage.removeItem(TRIAGE_FLAG)
  } catch {
    // Storage can be blocked; the reload below still drops the query flag.
  }
}
